import { SITE } from "@/lib/site";
import { PhysioBotLauncher } from "@/components/PhysioBot";

export function FloatingActions() {
  return (
    <>
    <PhysioBotLauncher />
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-5 right-5 z-40 inline-flex h-12 w-12 items-center justify-center rounded-full shadow-lg transition-transform hover:scale-110"
      style={{ backgroundColor: "#25D366" }}
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7" aria-hidden="true">
        <path
          fill="#ffffff"
          d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.795 1.23 1.82 2.734 3.41 4.769 4.34.616.287 2.035.888 2.72.888.817 0 2.335-.516 2.665-1.32.13-.33.13-.615.13-.945v-.17c0-.257-.286-.36-.502-.487-.402-.244-1.203-.632-1.518-.716l-.043-.014-.114-.017a.593.593 0 0 0-.716.372zm-3.024 7.582c-1.79 0-3.55-.487-5.075-1.418l-.36-.215-3.74.976 1.003-3.638-.237-.373a10.014 10.014 0 0 1-1.532-5.318c0-5.548 4.526-10.075 10.075-10.075 2.688 0 5.218 1.045 7.11 2.95a10.05 10.05 0 0 1 2.95 7.125c-.014 5.55-4.54 10.076-10.088 10.076zm0-22.155C9.408 2.632 4 8.038 4 14.686c0 2.13.56 4.198 1.618 6.036l-1.719 6.253 6.396-1.676a12.049 12.049 0 0 0 5.781 1.474h.014c6.679 0 12.174-5.406 12.174-12.056 0-3.24-1.36-6.278-3.61-8.564C22.395 3.892 19.35 2.632 16.086 2.632z"
        />
      </svg>
    </a>
    </>
  );
}
